class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.isHeaderTransparent = false;
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false);
  }

  open(event) {
    if (
      document
        .querySelector('.desktop-menu__curtain')
        ?.classList.contains('active')
    )
      return;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const header = document.querySelector('.header');
    if (header?.classList.contains('transparent')) {
      this.isHeaderTransparent = true;
      header?.classList.remove('transparent', 'delayed');
      setTimeout(() => {
        this.detailsContainer.setAttribute('open', true);
      }, 600);
    } else {
      this.detailsContainer.setAttribute('open', true);
    }
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    window.bodyScrollLock.lock();
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.classList.add('animate-close');
    setTimeout(() => {
      this.detailsContainer.classList.remove('animate-close');
      this.detailsContainer.removeAttribute('open');
      if (this.isHeaderTransparent) {
        document.querySelector('.header').classList.add('transparent');
        this.isHeaderTransparent = false;
      }
    }, 1200);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    window.bodyScrollLock.unlock();
  }
}

customElements.define('details-modal', DetailsModal);
